<template>
    <Dialog v-model:visible="internalValue" modal :closable="true" class="add-result-dialog" :header="`${$t('message.horseEdit.covering.dialogResultHeader')} ${horseName}`">
        <VeeForm @submit="saveResult" v-slot="{ isSubmitting }">
            <div class="flex flex-column gap-5">
                <div class="flex flex-column gap-3 w-full align-items-center">
                    <CustomInputText
                        v-if="!rowData.externalStallionName"
                        name="number"
                        class="w-8"
                        :label="$t('message.horseEdit.covering.numberResult')"
                        noPlaceholder
                        v-model="newResult.number"
                        disabled />
                    <CustomSelectOneResultType
                        name="resultType"
                        class="w-8"
                        :label="$t('message.horseEdit.covering.resultType')"
                        noPlaceholder
                        v-model="newResult.coveringResultType"
                        required
                        rules="required" />
                    <CustomCalendar v-if="!hideDate"
                                    name="date"
                                    class="w-8"
                                    :label="$t('message.horseEdit.covering.date')"
                                    noPlaceholder
                                    v-model="newResult.date"
                                    :required="!hideDate"
                                    rules="required" />
                </div>
                <div class="flex justify-content-center">
                    <CustomButton
                        type="submit"
                        :label="$t('message.horseEdit.covering.addResult')"
                        :disabled="isSubmitting" />
                </div>
            </div>
        </VeeForm>
    </Dialog>
</template>

<script>
    import _ from "lodash";
    import Dialog from "primevue/dialog";
    import { Form as VeeForm } from "vee-validate";
    import CustomCalendar from "@/components/form/CustomCalendar.vue";
    import CustomInputText from "@/components/form/CustomInputText.vue";
    import CustomButton from "@/components/form/CustomButton.vue";
    import {
        createOrUpdateCoveringResult,
    } from "@/swagger/vue-api-client";
    import CustomSelectOneResultType from "@/components/form/CustomSelectOneResultType.vue";

    export default {
        name: "AddResultDialog",

        components: {
            CustomInputText,
            CustomCalendar,
            Dialog,
            CustomButton,
            CustomSelectOneResultType,
            VeeForm,
        },

        props: {
            modelValue: null,
            horseName: {
                type: String,
                default: "",
            },
            rowData: null,
        },

        emits: ["search", "update:modelValue", "update:rowData"],

        data() {
            return {
                newResult: this.getClearResult(),
                hideDate: false,
            };
        },

        methods: {
            async saveResult() {
                try {
                    const newResultRequest = _.cloneDeep(this.newResult);

                    await createOrUpdateCoveringResult({body: newResultRequest});

                    this.$emit("search");
                    this.newResult = this.getClearResult();
                    this.internalRowData = null;
                    this.internalValue = false;
                    this.notifySaved();
                } catch (err) {
                    this.notifyError(err);
                }
            },
            notifySaved() {
                this.$toast.add({
                    severity: "success",
                    summary: this.$t("message.other.success"),
                    detail: this.$t("message.other.dataSaved"),
                    life: 3000,
                });
            },
            notifyError(error) {
                const message = error.response?.data?.message || this.$t("unknownError");
                this.$toast.add({
                    severity: "error",
                    summary: this.$t("message.other.error"),
                    detail: message,
                    life: 5000,
                });
            },
            getRequiredMessage(value) {
                if (this.showErrorMessages && (value === null || value === "")) {
                    return this.$t("message.validations.required");
                }
                return "";
            },
            getClearResult() {
                return {
                    coveringCertificateId: null,
                    number: null,
                    coveringResultType: null,
                    date: null,
                };
            },
        },

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },
            internalRowData: {
                get() {
                    return this.rowData;
                },
                set(value) {
                    this.$emit("update:rowData", value);
                },
            },
        },

        watch: {
            internalRowData: {
                handler(value) {
                    if (value) {
                        this.newResult.coveringCertificateId = value.id;
                        this.newResult.number = value.agreementNumber;
                    } else {
                        this.newResult = this.getClearResult();
                    }
                },
                deep: true,
            },
            "newResult.coveringResultType": function (value) {
                if (value === "BORN_FOAL" || value === "BORN_TWINS") {
                    this.newResult.date = null;
                    this.hideDate = true;
                } else {
                    this.hideDate = false;
                }
            },
        },
    };
</script>

<style lang="scss">
    .add-result-dialog {
        .custom-input-text, .custom-input-number, .custom-select-one, .custom-calendar, .custom-input-textarea {
            padding-left: 170px;
            .custom-label {
                z-index: 999;
                position: absolute;
                transform: translateX(-100%);
                left: 160px;
                text-align: right;
            }
        }
        &.p-dialog {
            min-width: 50%;
            .p-dialog-header {
                justify-content: space-between;
                .p-dialog-title {
                    color: var(--accent-color);
                    font-family: var(--decor-font-family);
                    font-weight: 500;
                    font-size: 25px;
                }
            }
            .p-dialog-content {
                padding: 1.5rem;
            }
        }
        .certificate-box {
            .custom-input-text:nth-of-type(1) {
                padding-left: 100px;
                right: -70px;
                .custom-label {
                    left: 90px;
                }
            }
            .custom-input-text:nth-of-type(2) {
                padding-left: 100px;
            }
        }
    }
</style>
